// 1️⃣ Imports must be at the top
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import $ from "jquery"; // import jQuery
import Swal from 'sweetalert2';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

window.$ = $;
window.jQuery = $;


const DashboardLayout = ({ children }) => {
  return (
    <div>
      <DashboardHeader />
        <section class="studentPanel">
            <Sidebar />
            {children}       
        </section>
      <Footer />
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default DashboardLayout;
